import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material";

const PublishDialog = ({ open, onClose, onConfirm, revision, loading }) => {
  const [notes, setNotes] = React.useState("");

  const handleConfirm = () => {
    onConfirm(notes);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 600, textAlign: "center" }}>
        Publish Schedule
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Review the revision number and add optional notes before publishing.
          </Typography>

          <TextField
            label="Revision"
            value={revision || ""}
            fullWidth
            InputProps={{ readOnly: true }}
            variant="outlined"
          />

          <TextField
            label="Notes"
            placeholder="Enter notes for this revision (optional)"
            fullWidth
            multiline
            minRows={2}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleConfirm}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          {loading ? "Publishing..." : "Publish"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PublishDialog;
